import styled from "styled-components";
import { SIPWrapper } from "../SourceInProgress/SourceInProgress.styles";
import { hexToRgba } from "../../utils/hexToRGBA";
import { isContrastWithDarkHigher } from "../ReusableStyledComponents/FontSetUtilities";

export const CBDWrapper = styled(SIPWrapper)<{$useYellow : boolean, $allowUserThemable: boolean}>`
    background: ${({ $useYellow, theme,  $allowUserThemable }) => {
        const cl = !$useYellow ?  theme.v3.colors.lightBlue : theme.v3.colors.lightYellow;
        return hexToRgba(cl, !$allowUserThemable ? 1 : isContrastWithDarkHigher(theme.customization.backgroundColor) ? 1 : 0.9);
    }};
    border: 1px solid ${({ $useYellow, theme }) => $useYellow ? theme.v3.colors.midYellow : "rgba(127, 167, 246, 0.3)"};
`;